<template>
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <div class="panel profile-panel profile-team">
                <template v-if="teams.length">
                    <h3 class="text-center" v-text="$t('wi.teams')"></h3>
                    <div id="teams">
                        <draggable @end="arrangeTeams" v-model="teamsData"
                                   :options="{animation: 150, disabled: roles.is_public, forceFallback: true}">
                            <div class="tw-mb-12" :class="{'tw-cursor-move' : ! roles.is_public}"
                                 v-for="(team, index) in teams">
                                <div class="tw-flex tw-justify-between tw-items-start tw-border-b tw-border-grey-light tw-pb-6 tw-mb-4">
                                    <div class="tw-flex tw-flex-col">
                                        <span class="tw-font-thin"
                                              v-if="team.metas[0].value.start_year && team.metas[0].value.end_year">{{ `${team.metas[0].value.start_year} - ${team.metas[0].value.end_year}` }}</span>
                                        <strong v-text="team.metas[0].value.name"></strong>
                                    </div>
                                    <div class="tw-flex tw-justify-end tw-items-center">
                                        <delete-button
                                                :item-id="team.id"
                                                type="teams"
                                                :message="`${$t('wi.sure_to_delete')} ${team.metas[0].value.name} ${$t('wi.team_from_your_profile')}`"

                                        />
                                        <edit-button
                                                modal-target="editTeam"
                                                :modal="{title: $t('wi.edit_your_team'), index}"
                                        />
                                    </div>
                                </div>
                                <p class="tw-my-6" v-text="team.metas[0].value.comments"></p>
                                <div class="tw-flex">
                                    <div class="tw-w-1/3 tw-flex tw-flex-col"
                                         v-for="member in team.metas[0].value.members">
                                        <span v-text="member.title" v-if="member.title"></span>
                                        <span v-text="member.name" v-if="member.name"></span>
                                        <span v-text="member.phone" v-if="member.phone"></span>
                                        <a :href="`mailto:${member.email}`" v-text="member.email" v-if="member.email"></a>
                                    </div>
                                </div>
                            </div>
                        </draggable>
                        <add-button modal-target="editTeam" :modal="{title: $t('wi.add_your_team_information')}"/>
                    </div>
                </template>
                <empty-state
                        v-else
                        :title="$t('wi.teams')"
                        :description="$t('wi.you_didnot_get_here_alone')"
                        :button="{caption: $t('wi.add_team')}"
                        :modal="{title: $t('wi.add_your_team_information')}"
                        modalTarget='editTeam'
                />
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex';
    import EditButton from '../VisualElements/EditButton';
    import DeleteButton from '../VisualElements/DeleteButton';
    import AddButton from '../VisualElements/AddButton';
    import EmptyState from '../EmptyState';
    import draggable from 'vuedraggable';

    export default {
        name: "Teams",
        components: {
            EditButton,
            DeleteButton,
            AddButton,
            EmptyState,
            draggable
        },
        computed: {
            ...mapGetters({
                roles: 'player-profile/roles',
                teams: 'player-profile/teams',
                profileData: 'player-profile/profile'
            }),
            teamsData: {
                get() {
                    return this.teams;
                },
                set(value) {
                    this.setTeams(value);
                }
            }
        },
        methods: {
            ...mapMutations({
                setTeams: 'player-profile/setTeams'
            }),
            ...mapActions({
                updateOrder: 'player-profile/updateOrder'
            }),
            arrangeTeams() {
                let orders = this.teams.map(team => {
                    return {id: team.id}
                });

                this.updateOrder({
                    type: 'team',
                    orders
                })
            }
        }
    }
</script>

<style scoped>

</style>